import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, blueMui, greyMui, redMui, rydeColors } from "@ryde/theme";

export const CourseSchedulesPreviewWrapper = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "course-schedules-preview-wrapper",
  },
)`
  margin: 8px 0 16px;
  padding-inline-end: 24px;

  .course-schedules__filters {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin: 0 0 12px;
    align-items: flex-start;
  }

  .course-schedules__filter {
    min-width: 0;
  }

  .course-schedules__filter--direction {
    flex: 0 1 160px;

    /* Close outlined notch when floating label sits inside as placeholder */
    .MuiInputLabel-root:not(.MuiInputLabel-shrink)
      + .MuiInputBase-root
      .MuiOutlinedInput-notchedOutline
      legend {
      max-width: 0.01px;
      padding: 0;
      transition: none;
    }
  }

  .course-schedules__filter--course {
    flex: 1 1 200px;
  }

  .course-schedules__filter-empty {
    color: ${blueGreyMui._400};
  }

  .course-schedules__count {
    margin: 0 0 8px;
    font-size: 13px;
    font-weight: 600;
    color: ${blueGreyMui._600};
    text-align: end;
  }

  .course-schedules__table {
    border: 1px solid ${blueGreyMui._100};
    border-radius: 8px;
    overflow: hidden;
    /* Keep column text LTR so headers align with data even in RTL app locale */
    direction: ltr /* @noflip */;
  }

  .course-schedules__row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 110px 130px;
    column-gap: 12px;
    align-items: center;
    justify-items: stretch;
    padding: 10px 12px;
    border-bottom: 1px solid ${blueGreyMui._100};
    font-size: 12px;
    font-weight: 500;
    color: ${rydeColors.black};

    &:last-child {
      border-bottom: none;
    }
  }

  .course-schedules__table--with-existing .course-schedules__row {
    grid-template-columns: minmax(0, 1fr) 90px 120px 70px minmax(100px, 0.9fr);
  }

  .course-schedules__row--header {
    padding: 8px 12px;
    background-color: ${blueGreyMui._50};
    font-weight: 700;
    color: ${blueGreyMui._700};
  }

  .course-schedules__course-cell {
    display: flex;
    align-items: center;
    min-width: 0;
    gap: 6px;
    /* Hebrew course names still render correctly inside LTR table */
    unicode-bidi: plaintext;
  }

  .course-schedules__type-icon {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    line-height: 0;

    svg {
      width: 16px;
      height: 16px;
    }
  }

  .course-schedules__course-id {
    flex-shrink: 0;
  }

  .course-schedules__course-id--clickable {
    cursor: pointer;
    color: ${blueGreyMui._900};
    text-decoration: underline;
    transition: color 0.2s ease;

    &:hover {
      color: ${greyMui.A700};
    }

    &:focus-visible {
      outline: 2px solid ${greyMui.A400};
      outline-offset: 2px;
      border-radius: 2px;
    }
  }

  .course-schedules__course-name {
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-inline-end: 8px;
    text-decoration: none;
    color: ${rydeColors.black};
    font-weight: 500;
  }

  .course-schedules__direction,
  .course-schedules__when {
    display: block;
    width: 100%;
    box-sizing: border-box;
    white-space: nowrap;
    text-align: left /* @noflip */;
    direction: ltr /* @noflip */;
  }

  .course-schedules__ride,
  .course-schedules__status {
    display: block;
    width: 100%;
    box-sizing: border-box;
    white-space: nowrap;
    text-align: left /* @noflip */;
    direction: ltr /* @noflip */;
    font-weight: 600;
    color: ${blueGreyMui._800};
  }

  .course-schedules__status--canceled {
    color: ${rydeColors.red};
  }

  .course-schedules__ride-id-row {
    display: inline-flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 0;
  }

  .course-schedules__ride-status {
    font-weight: 600;
    color: inherit;
    margin-inline-start: 4px;
  }

  .course-schedules__ride-id--clickable {
    cursor: pointer;
    text-decoration: underline;
    color: ${blueGreyMui._900};
    transition: color 0.2s ease;

    &:hover {
      color: ${greyMui.A700};
    }

    &:focus-visible {
      outline: 2px solid ${greyMui.A400};
      outline-offset: 2px;
      border-radius: 2px;
    }
  }

  .course-schedules__direction {
    color: ${blueGreyMui._700};
    font-weight: 600;
  }

  .course-schedules__direction--a {
    color: ${redMui._800};
  }

  .course-schedules__direction--b {
    color: ${blueMui._800};
  }

  .course-schedules__when {
    color: ${blueGreyMui._800};
    font-weight: 600;
  }

  .course-schedules__row--header .course-schedules__direction,
  .course-schedules__row--header .course-schedules__when {
    font-weight: 700;
    color: ${blueGreyMui._700};
  }

  .course-schedules__empty,
  .course-schedules__loading {
    padding: 16px 12px;
    font-size: 12px;
    color: ${blueGreyMui._600};
  }
`;
